// constructing className strings conditionally
// doc: https://github.com/lukeed/clsx
import clsx from "clsx";

export const cn = clsx;
